@if (!readOnly) {
  <mat-form-field class="searchField" appearance="outline">
    <input
      matInput
      autocomplete="off"
      type="text"
      placeholder="Search by name"
      [(ngModel)]="search"
      />
  </mat-form-field>
}
@if ((organisations | keyvalue)?.length > 0) {
  <div
    class="flex flex-col"
    >
    @for (
      row of organisations
      | keyvalue
      | organisationSortPipe
      | organisationFilterPipe : search
      ; track
      row) {
      <div
        matRipple
        class="item flex flex-row justify-start items-center"
        [class.selected]="selectedIds?.includes(row.key)"
        [class.disabled]="disabledIds?.includes(row.key)"
    (click)="
      readOnly || disabledIds?.includes(row.key) ? null : toggle(row.value)
    "
        >
        <div class="avatar">
          <ca-avatar [fullName]="row.value.name" [fontSize]="15"> </ca-avatar>
        </div>
        <div class="organisation-name">
          <h3>{{ row.value.name }}</h3>
        </div>
      </div>
    }
  </div>
} @else {
  <p>
    {{ "organisations.select.empty" | translate }}
  </p>
}
